import { useCallback, useContext, useState } from "react";
import { useOrganisation } from "./useOrganisation"
import { InventoryContext } from "@database/contexts";
import { CreateNewInventoryType, ErrorType } from "@utilities/types";
import { inventoryServices } from "@database/services";

export const useInventory = ()=> {
    
    const { 
        invertories, setInvertories,
    } = useContext(InventoryContext);
    const { organisation } = useOrganisation();

    const [getAllOrganisationInventoryLoading, setGetAllOrganisationInventoryLoading] = useState<boolean>(false);
    const [getAllOrganisationInventoryError, setGetAllOrganisationInventoryError] = useState<ErrorType | null>(null);
    const [createInventoryLoading, setCreateInventoryLoading] = useState<boolean>(false);
    const [createInventoryError, setCreateInventoryError] = useState<ErrorType | null>(null);

    const onGetAllOrganisationInvertories = useCallback(async()=> {
        if(!organisation) return;

        setGetAllOrganisationInventoryLoading(true);
        const req = await inventoryServices.getAllOrganisationInventory(organisation._id);

        if(req.code === 200) {
            setInvertories(req.data);
            setGetAllOrganisationInventoryError(null);
        } else {
            setInvertories(null);
            setGetAllOrganisationInventoryError({
                message: "Une erreur est survenue, veuillez réessayer",
            });
        }
        setGetAllOrganisationInventoryLoading(false);
    }, [organisation, setInvertories]);

    const onCreateInventory = useCallback(async (newInventory: Partial<CreateNewInventoryType>)=> {
        if(!organisation) return;

        setCreateInventoryLoading(true);
        const req = await inventoryServices.newInventory({
            ...newInventory,
            organisationID: organisation._id,
        });

        if(req.code === 201) {
            await onGetAllOrganisationInvertories();
            setCreateInventoryError(null);
        } else {
            setCreateInventoryError({
                message: "Une erreur est survenue, veuillez réessayer",
            });
        }
        setCreateInventoryLoading(false);
    }, [organisation, onGetAllOrganisationInvertories]);

    return {
        invertories, getAllOrganisationInventoryLoading,
        getAllOrganisationInventoryError, createInventoryLoading,
        createInventoryError,
        onCreateInventory, onGetAllOrganisationInvertories,
    }
}
